import * as React from 'react';
import { XYCoord, useDragLayer } from 'react-dnd';
import { ItemTypes } from '../types';
import { DragTag } from './drag-tag';
import styles from './drag-tag.scss';

const getItemStyles = (
  initialOffset: XYCoord | null,
  currentOffset: XYCoord | null
) => {
  if (!initialOffset || !currentOffset) {
    return {
      display: 'none'
    };
  }

  const { x, y } = currentOffset;
  const transform = `translate(${x}px, ${y}px)`;

  return {
    transform,
    WebkitTransform: transform
  };
};

export const CustomDragLayer: React.FC<React.PropsWithChildren> = () => {
  const {
    itemType,
    isDragging,
    item,
    initialOffset,
    currentOffset
  } = useDragLayer((monitor) => ({
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
    initialOffset: monitor.getInitialSourceClientOffset(),
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging()
  }));

  const renderItem = () => {
    if (itemType in ItemTypes && itemType !== ItemTypes.GROUPBY_SORT) {
      return <DragTag title={item.field.description} active={false} />;
    }
    return <div />;
  };

  if (!isDragging) {
    return null;
  }

  return (
    <div className={styles.previewContainer}>
      <div style={getItemStyles(initialOffset, currentOffset)} className={styles.previewTag} >
        {renderItem()}
      </div>
    </div>
  );
};

class DragNDropComponent extends React.Component<React.PropsWithChildren> {

  public render(): JSX.Element {
    return (<div>
      <CustomDragLayer />
      {this.props.children}
    </div>);
  }
}

export const DragNDrop = (props: any) => (
  <DragNDropComponent children={props.children} />
);
